import { __ } from '../translations';
import { ICustomConfigurationService } from '@intigral/domain/lib/application/services/CustomConfigurationService';
import { container } from '@intigral/domain/lib/DataDomain';
import { DI } from '@intigral/constant/config/DIContainer';
import { Footer as WCPFooter } from '@intigral/ui/components/Footer';
import { useQuery } from '@tanstack/react-query';
import useLanguage from '../hooks/useLanguage';

export const Footer = () => {
    const language = useLanguage();

    const customService = container.resolve<ICustomConfigurationService>(DI.SERVICES.ICustomConfigurationService);
    const { data, error, isLoading } = useQuery({
        queryKey: ['footerMenu', language],
        queryFn: async () => {
            const result = await customService.getFooterMenuContent();
            return result || { footerMenu: [], socialMediaLinks: [], appLinks: [] };
        },
    });

    if (isLoading) {
        return null;
    }

    const companyURL = `<a href=${__('home_footer_intigral_link')} target=_blank>${__('home_footer_intigral')}</a>`;
    const currentYear = new Date().getFullYear();

    const copyrights = __('home_footer_copyright_text', {
        COMPANY_URL: companyURL,
        YEAR: currentYear,
    });

    // const copyrights = __('home_footer_copyright') +
    //     ' ' +
    //     new Date().getFullYear() +
    //     ' <a href=' +
    //     __('home_footer_intigral_link') +
    //     'target=_blank>' +
    //     __('home_footer_intigral') +
    //     '</a>' +
    //     __('home_footer_all_right');

    const navlinks = data?.footerMenu?.map((link) => {
        return {
            text: language === 'ar' ? link.label.ar : link.label.en,
            link: language === 'ar' ? link.url.ar : link?.url.en,
            image: '',
            target: link.target,
        };
    });
    const socialLinks = data?.socialMediaLinks?.map((link) => {
        return {
            link: link.link,
            text: language === 'ar' ? link.label.ar : link.label.en,
            image: link.imageUrl,
            target: link.target,
        };
    });

    const mappedAppLinks = data.appLinks?.map((link) => {
        return {
            link: link.link,
            text: language === 'ar' ? link.label.ar : link.label.en,
            image: link.imageUrl,
            target: link.target,
        };
    });

    return (
        <>
            <WCPFooter
                navLinks={navlinks}
                appsLinks={mappedAppLinks}
                copyrightText={copyrights}
                socialMediaLinks={socialLinks}
                LinkComponent="a"
            />
        </>
    );
};
